/**
 * Utility to parse Google Maps Place object into a structured address object.
 * 
 * @param {google.maps.places.PlaceResult} place - The place result from Google Maps Autocomplete or Geocoder.
 * @returns {Object} Structured address object with streetAddress, city, state, country, zipCode, and displayAddress.
 */
export const parseGooglePlace = (place) => {
    let location = {
        streetAddress: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        displayAddress: "",
    };

    if (!place || !place.address_components) {
        return location;
    }

    let streetNumber = "";
    let route = "";
    let subpremise = "";
    let premise = "";
    let neighborhood = "";

    for (const component of place.address_components) {
        const types = component.types;

        if (types.includes("street_number")) {
            streetNumber = component.long_name;
        } else if (types.includes("route")) {
            route = component.long_name;
        } else if (types.includes("subpremise")) {
            subpremise = component.long_name;
        } else if (types.includes("premise")) {
            premise = component.long_name;
        } else if (types.includes("neighborhood")) {
            neighborhood = component.long_name;
        } else if (types.includes("locality") || types.includes("sublocality_level_1")) {
            location.city = component.long_name;
        } else if (types.includes("administrative_area_level_1")) {
            location.state = component.long_name;
        } else if (types.includes("country")) {
            location.country = component.long_name;
        } else if (types.includes("postal_code")) {
            location.zipCode = component.long_name;
        }
    }

    // Build Street Address
    let streetParts = [];
    if (streetNumber) streetParts.push(streetNumber);
    if (route) streetParts.push(route);

    location.streetAddress = streetParts.join(" ");

    if (subpremise) {
        location.streetAddress += (location.streetAddress ? ", " : "") + subpremise;
    } else if (premise && !location.streetAddress) {
        location.streetAddress = premise;
    } else if (neighborhood && !location.streetAddress) {
        location.streetAddress = neighborhood;
    }

    // Fallback if we still don't have a street address
    if (!location.streetAddress && place.formatted_address) {
        const parts = place.formatted_address.split(",");
        let candidate = parts[0].trim();

        // If the candidate is just the city or state, try to find a better one
        if (candidate === location.city || candidate === location.state) {
            if (parts.length > 1) {
                // This shouldn't happen with formatted_address usually, but just in case
            }
        }
        location.streetAddress = candidate;
    }

    // Final safety: ensure streetAddress doesn't accidentally contain the full address if street_number/route were somehow the whole thing
    if (location.streetAddress === place.formatted_address && place.formatted_address.includes(",")) {
        const parts = place.formatted_address.split(",");
        location.streetAddress = parts[0].trim();
    }

    location.displayAddress = location.streetAddress;
    return location;
};
